__webpack_require__.p = "https://simplywall.st/static/js/";